import React, {Component} from "react";
import {setUserActive, setUserAuth, setUserData, setUserDebts, setUserToken} from "../../store/user/actions";
import {setTapBarData} from "../../store/tapBar/actions";
import {setBankTransferType, setCardTransferData} from "../../store/transfer/actions";
import {connect} from "react-redux";
import {withRouter} from "@happysanta/router";
import {Button, Div, Group, Text} from "@vkontakte/vkui";
import axios from "../../axios/axios";
import {SERVER_CONFIG} from "../../config";
import SnackBarSuccess from "../../components/UI/SnackBar/SnackBarSuccess";
import {setSnackBarData} from "../../store/snackBar/actions";
import SnackBarWarning from "../../components/UI/SnackBar/SnackBarWarning";
import Moment from 'moment/moment'


class EducationItem extends Component {

    state = {
        buttonDisabled: true,
        buttonText: 'Обучиться'
    }
    async educationAdd() {
        const item = this.props.item
        console.log('item')
        await this.setState({
            buttonDisabled: true,
            buttonText: 'Идет обучение'
        })
        axios.post('education/' + item.id, {}, SERVER_CONFIG)
            .then(() => {
                SnackBarSuccess('Обучение началось', this.props.setSnackBarData.bind(this))
                axios.get('info', SERVER_CONFIG)
                    .then(res => res.data)
                    .then(res => {
                        setUserData(res)
                    })
            })
            .catch(e => {
                this.setState({
                    buttonDisabled: false,
                    buttonText: 'Обучиться'
                });
                e.response?.data?.message ? SnackBarWarning(e.response?.data?.message, this.props.setSnackBarData.bind(this)) : null
            })


    }

    componentDidMount() {
        const item = this.props.item
        const user = this.props.user
        if (user.data?.level >= item.level && user.data?.bank >= item.price) {
            this.setState({
                buttonDisabled: false
            })
        }else {
            this.setState({
                buttonDisabled: true
            })
        }
    }

    render() {
        const item = this.props.item
        const user = this.props.user
        const educations = user?.data?.educations ?? []
        const userEducation = user.data?.educations?.length > 0 ? user.data?.educations?.filter(education => item.id === education.id) : []
        const hoursLast = userEducation.length > 0 ? parseInt(userEducation[0].pivot?.timestamp) + parseInt(item.time)  * 60 * 60 - Moment().unix() : 0
        return (
            <Group>
                <Div style={{fontSize: 17}}>{item.title}</Div>
                <Div style={{fontSize: 14, paddingTop: 0, paddingBottom: 0, color: '#484848'}}>{item.description}</Div>
                <Div style={{paddingBottom: 0, color: user.data?.level >= item.level ? 'green' : "red"}}>Уровень: <span style={{fontWeight: 600} }>{item.level}</span></Div>
                <Div style={{paddingBottom: 0}}>Exp: <span style={{fontWeight: 600} }>{
                    userEducation.length > 0 ? (
                        userEducation[0]?.pivot?.exp + ' / '
                    ) : null
                }{item.exp}</span></Div>
                <Div style={{paddingBottom: 0}}>Время на обучение: {item.time} ч</Div>
                {
                    userEducation.length > 0 && userEducation[0].exp > userEducation[0].pivot?.exp ? (
                        <Div style={{paddingBottom: 0}}>Осталось времени: {hoursLast > 0 ? Math.floor(hoursLast / 60 / 60) : 0} ч {hoursLast > 0 ? Math.floor((hoursLast / 60) % 60) + 'мин' : null}</Div>
                    ) : null
                }

                <Div style={{paddingBottom: 0, color: user.data?.bank >= item.price ? 'green' : "red"}}>Стоимость обучения: {item.price} руб</Div>
                <Div>
                    {userEducation?.length > 0 ? (
                        userEducation[0].pivot.exp < userEducation[0].exp ? (
                            <Button disabled={true}>Идет обучение</Button>
                            ) : (
                            <Button disabled={true}>Вы уже обучены</Button>
                        )

                    ) : (
                        <Button disabled={this.state.buttonDisabled} onClick={this.educationAdd.bind(this) } >{this.state.buttonText}</Button>
                    ) }

                </Div>
            </Group>

        )
    }

}

const mapStateToProps = (state) => {
        return {
            user: state.user,
            tapBar: state.tapBar,
            transfer: state.transfer
        };
    }
;

const mapDispatchToProps =
    {
        setUserData,
        setUserAuth,
        setUserToken,
        setUserActive,
        setUserDebts,
        setTapBarData,
        setCardTransferData,
        setBankTransferType,
        setSnackBarData
    }
;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EducationItem));